import { observeCLS, observeFID, observeLCP } from './webVitalsObservers.js'

function reportNavigation(report) {
  try {
    const nav = performance.getEntriesByType('navigation')[0]
    if (!nav) return
    report({ name: 'TTFB', value: nav.responseStart, unit: 'ms' })
    report({ name: 'DCL', value: nav.domContentLoadedEventEnd, unit: 'ms' })
    report({ name: 'LOAD', value: nav.loadEventEnd, unit: 'ms' })
  } catch {
    /* getEntriesByType not available in some test envs */
  }
}

export function startWebVitals(reporter) {
  if (typeof window === 'undefined' || typeof PerformanceObserver === 'undefined') {
    return () => {}
  }
  const safeReporter = (sample) => {
    try {
      reporter(sample)
    } catch (err) {
      if (import.meta.env.DEV) console.error('[webVitals] reporter threw', err)
    }
  }
  reportNavigation(safeReporter)
  const cleanups = [observeLCP(safeReporter), observeFID(safeReporter), observeCLS(safeReporter)]
  return () => {
    for (const fn of cleanups) {
      try {
        fn()
      } catch {
        /* ignore */
      }
    }
  }
}
